var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{class:`traveler-label`},[(_vm.use_name)?_c('span',[_vm._v(" "+_vm._s(_vm.traveler_name)+" ")]):_c('span',[_vm._v(" Passeggero "),(_vm.index >= 0)?_c('span',[_vm._v(_vm._s(_vm.index + 1)+" ")]):_c('span',[_vm._v(_vm._s(_vm.traveler_info.id))])]),_c('span',[_vm._v("("+_vm._s(_vm.traveler_type)+")")]),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }